<template>
  <li class="vr360-app__all-streams__list__item">
    <div class="vr360-app__stream">
      <div class="vr360-app__stream__header">
        <p class="vr360-app__stream__header__avatar">
          <template v-if="stream.owner.avatar">
            <img class="vr360-avatar-stub" :src="stream.owner.avatar | storagePath" alt>
          </template>
          <template v-else>
            <img class="vr360-avatar-stub" :src="'#'" alt>
          </template>
          <span class="vr360-text-elips vr360-text-reg">
            <template v-if="!stream.owner.name && !stream.owner.surname">
              {{stream.owner.email}}
            </template>
            <template v-else>
              {{stream.owner.name}} {{stream.owner.surname}}
            </template>
          </span>
        </p>
        <p class="vr360-live" v-if="stream.live">
          <span class="vr360-text-caption">Live</span>
        </p>
      </div>

      <a href="stream" @click.prevent="showStream" class="vr360-app__stream__main">
        <div class="vr360-stream-stub vr360-app__stream__main__poster">
          <template v-if="stream.poster">
            <img :src="stream.poster | storagePath" alt>
          </template>
          <!-- <span class="vr360-text-caption vr360-text-white">{{stream.duration | secondsTohhmmss }}</span> -->
        </div>
        <p class="vr360-head-h4">{{stream.title}}</p>
      </a>

      <div class="vr360-app__stream__footer">
        <p class="vr360-app__stream__footer__likes">
          <button
            type="button"
            class="vr360-checkbox-like"
            :class="{ 'is-liked' : stream.isLikedMe }"
            @click="toggleLike"
          >
            <i class="vr360-icon bg-like"></i>
            <span></span>
          </button>
          <span class="vr360-text-caption">{{stream.likes_count}}</span>
        </p>
        <p class="vr360-app__stream__footer__views">
          <i class="vr360-icon bg-eye"></i>
          <span class="vr360-text-caption">{{stream.watched}}</span>
        </p>
      </div>
    </div>
  </li>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "item-public-stream",
  props: {
    stream: {
      type: Object,
      required: true
    }
  },
  methods: {
    ...mapActions({
      toggleLikeStream: "stream/toggleLikeStream",
      selectStream: "stream/selectStream",
      setPositionScrollY: "setPositionScrollY"
    }),
    showStream(e) {
      e.preventDefault();
      this.setPositionScrollY(this.getScrollBlock.scrollTop);
      this.selectStream(this.stream.id);
      this.$router.push({
        name: "ItemPublicStream",
        params: { id: this.stream.id }
      });
    },
    toggleLike(event) {
      let target = event.target;

      while (
        !target.classList.contains("vr360-checkbox-like") &&
        target !== document.body
      ) {
        target = target.parentElement;
      }

      function likeAnimEnd() {
        target.style.animation = "";
        target.removeEventListener("animationend", likeAnimEnd);
      }

      target.addEventListener("animationend", likeAnimEnd);
      target.style.animation = "var(--btnHoverScaleAnim)";

      this.toggleLikeStream(this.stream.id);
    }
  },
  computed: {
    ...mapGetters({
      getScrollBlock: "getScrollBlock"
    })
  }
};
</script>

<style lang="scss">
</style>
